import React, { useState, useEffect } from 'react';
import "./retailerdetails.scss";
import { pgmdetailAction } from "../../actions/pgmlistAction";
import { useDispatch } from "react-redux";
import { useParams } from 'react-router-dom'
import { useNavigate } from "react-router-dom";
import { decode } from "base-64";
import Header from "../../component/loaderComponent/Header/Header";
import RetailerDetailsSkeleton from "../../component/SkeletonLoader/RetailerDetailsSkeleton";
import useMobileView from "../../constants/useMobileView";
import TabNavigation from "./components/TabNavigation";
import LeftColumnSection from "./components/LeftColumnSection";
import RightColumnSection from "./components/RightColumnSection";
import LinkedCustomersTable from "./components/LinkedCustomersTable";


function RetailerDetails() {
  const [state, setDataState] = useState({
    pgmdetail: [],
    mobile_number: "",
    pincode: "",
    user_name: "",
    email: "",
    city: "",
    account_number: "",
    district: "",
    state: "",
    is_approve: "",
    verification_type: "",
    verification_id: "",
    shop_name: "",
    pgm_status: "",
    profile: "",
    banner: '',
    doc_file: '',
    agency_code: '',
    refer_code: '',
    aps_code: '',
    aps_name: '',
    area_head_email: '',
    location_link: "",
    registered_at: '',
    linked_customers: [],
  });
  const [activeTab, setActiveTab] = useState('details');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { isSidebarOpen, toggleSidebar } = useMobileView();


  const dispatch = useDispatch();
  useEffect(() => {
    RetailerDetailData();
  }, []);

  const { id } = useParams()
  const decodeid = decode(id)

  async function RetailerDetailData() {
    let response = await dispatch(pgmdetailAction(decodeid));
    if (response == 200 || response != null) {
      setDataState({
        pgmdetail: response.data.data,
        mobile_number: response.data.data.mobile_number,
        location_link: response.data.data.location_link,
        pincode: response.data.data.pincode,
        account_number: response.data.data.account_number,
        email: response.data.data.email,
        city: response.data.data.city,
        user_name: response.data.data.name,
        district: response.data.data.district,
        state: response.data.data.state,
        is_approve: response.data.data.is_approve,
        is_deleted: response.data.data.is_deleted,
        verification_type: response.data.data.doc_type,
        verification_id: response.data.data.doc_id,
        shop_name: response.data.data.garage_name,
        shop_location: response.data.data.location,
        pgm_status: response.data.data.pgm_status,
        profile: response.data.data.profile,
        banner: response.data.data.banner,
        doc_file: response.data.data.doc_file,
        agency_code: response.data.data.agency_code,
        refer_code: response.data.data.referred_by_refer_code,
        aps_code: response.data.data.aps_code,
        aps_name: response.data.data.aps_name,
        area_head_email: response.data.data.area_head_email,
        id: response?.data?.data?.id,
        registered_at: response?.data?.data?.registered_at,
        linked_customers: response.data.data.linked_customers || [],
      });
    }
  };

  const onclose = () => {
    window.scroll(0, 0);
    navigate('/retailerList')
  }

  const handleChange = (evt) => {
    const value = evt.target.value;
    setDataState({
      ...state,
      [evt.target.name]: value.replace(/^ +/gm, ""),
    });
  };

  return (
    <div className='reatiler-details-3w'>
      <div className={`DetailsContainers ${isSidebarOpen ? 'sidebar-open' : ''}`}>
        <div className="DetailsContentS pgm_details_container_s">
          <Header title="Retailer Details" />

          {!isLoading && (
            <TabNavigation activeTab={activeTab} setActiveTab={setActiveTab} />
          )}

          {isLoading ? (
            <RetailerDetailsSkeleton />
          ) : (
            <>
              <div className="retailerdetails-header">
                {activeTab === 'details' && (
                  <div className="TextConatinerDetails">
                    <LeftColumnSection state={state} />
                    <RightColumnSection state={state} handleChange={handleChange} />
                  </div>
                )}

                {activeTab === 'customers' && (
                  <LinkedCustomersTable customers={state.linked_customers} />
                )}

                <div className="pgmdetails_button">
                  <button className="pgm_buttonPending" onClick={onclose}>
                    Close
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default RetailerDetails;